import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createPinia } from 'pinia'
import './style.css'
import App from './App.vue'
import { setupRouterGuards } from './router/guards'
import { useAuthStore } from './stores/auth'

// Import pages
import Dashboard from './pages/Dashboard.vue'
import Login from './pages/Login.vue'
import Register from './pages/Register.vue'
import Agents from './pages/Agents.vue'
import Domains from './pages/Domains.vue'
import Tickets from './pages/Tickets.vue'
import Settings from './pages/Settings.vue'
import Analytics from './pages/Analytics.vue'
import KnowledgeBase from './pages/KnowledgeBase.vue'
import Tools from './pages/Tools.vue'
import Profile from './pages/Profile.vue'
import Security from './pages/Security.vue'
import Billing from './pages/Billing.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/login', component: Login, meta: { requiresAuth: false } },
    { path: '/register', component: Register, meta: { requiresAuth: false } },
    { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true } },
    { path: '/agents', component: Agents, meta: { requiresAuth: true } },
    { path: '/agents/new', component: Agents, meta: { requiresAuth: true } },
    { path: '/domains', component: Domains, meta: { requiresAuth: true } },
    { path: '/analytics', component: Analytics, meta: { requiresAuth: true } },
    { path: '/knowledge', component: KnowledgeBase, meta: { requiresAuth: true } },
    { path: '/tools', component: Tools, meta: { requiresAuth: true } },
    { path: '/profile', component: Profile, meta: { requiresAuth: true } },
    { path: '/security', component: Security, meta: { requiresAuth: true } },
    { path: '/billing', component: Billing, meta: { requiresAuth: true } },
    { path: '/tickets', component: Tickets, meta: { requiresAuth: true } },
    { path: '/settings', component: Settings, meta: { requiresAuth: true } },
  ]
})

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)

// Setup router guards BEFORE mounting
setupRouterGuards(router)

// Initialize auth store and mount app
const authStore = useAuthStore()
const query = new URLSearchParams(window.location.search)
const impersonationToken = query.get('impersonationToken')
if (impersonationToken) {
  localStorage.setItem('token', impersonationToken)
  localStorage.setItem('isImpersonating', 'true')
  window.history.replaceState({}, document.title, window.location.pathname)
}

authStore.initialize().then(() => {

  // Check if user is trying to access protected route without auth
  const currentPath = window.location.pathname
  const protectedRoutes = ['/dashboard', '/agents', '/domains', '/tickets', '/settings', '/analytics', '/knowledge', '/tools', '/profile', '/security', '/billing']
  const isProtectedRoute = protectedRoutes.some(route => currentPath.startsWith(route))
  
  if (isProtectedRoute && !authStore.isAuthenticated) {
    router.push('/login')
  }
  
  app.mount('#app')
})
